<div class="left-container" [class.full-size]="inSettings">
  <div class="mobile-content" *ngIf="offerSet?.enable_membership_goal || offerSet?.enable_contribution_goal">
    <tyt-donations-goals
      [offerSet]="offerSet"
      [period]="period"
      ></tyt-donations-goals>
  </div>

  <div [class.hidden-banner]="!showAttentionBanner" *ngIf="attentionBanner" class="membership-value-title">
    <img class="logo" src="/assets/tyt.svg" />
    {{ attentionBanner }}
  </div>
  <div class="step-container">
    <tyt-pricing-offers-step
      *ngIf="step === 'pricing'"
      [offerSet]="offerSet"
      [inSettings]="inSettings"
      [previewing]="previewing"
      [showNoThanks]="showNoThanks"
      [knownEmail]="knownEmail"
      [knownFirstName]="knownFirstName"
      (periodChanged)="onPricingStepChangedPeriod($event)"
      ></tyt-pricing-offers-step>
    <tyt-signup-offers-step
      *ngIf="step === 'signup'"
      [offerSet]="offerSet"
      [mode]="signupStepMode"
      [knownEmail]="knownEmail"
      [knownFirstName]="knownFirstName"
      ></tyt-signup-offers-step>
    <tyt-payment-offers-step
      *ngIf="step === 'payment'"
      [offerSet]="offerSet"
      [offerSetUUID]="offerSet?.uuid"
      [offer]="offer"
      [offerUUID]="offerUUID"
      [price]="price"
      [inSettings]="inSettings"
      [period]="period"
      ></tyt-payment-offers-step>
  </div>
  <div class="step-selection" [class.in-settings]="inSettings">
    <a
      [class.hidden-back]="!showGoBackOption"
      (click)="goBack()"
      class="go-back"
      aria-label="Back to previous step"
      *ngIf="step === 'signup'"
      >
        <img src="/assets/offers/arrow-left.svg" aria-label="Arrow facing left" alt="&lt;-">BACK
    </a>
    <div *ngFor="let key of objectKeys(steps)"
      class="step"
      [class.active]="step === key"
      attr.aria-label="Step {{ steps[key].title }}">{{ steps[key].title }}</div>
  </div>
</div>
